import React from "react";
import { Engagement as EngagementItem } from "./Engagement";
import EngagementInfoModal from "./EngagementInfoModal";
import DisengageJobModal from "./DisengageJobModal";
import Engagement from "../../apiResources/Engagement";
import CurrentUser from "../../apiResources/CurrentUser";
import { useModal } from "../../hooks";

const EngagementItemCardStyleOverrides = {
  border: "1px solid #e6e6e6",
  padding: "1rem",
  marginBottom: "1rem",
  borderRadius: "5px",
  width: "100% !important",
  position: "relative",
};

const EngagementListCard = (props: Props) => {
  const { engagement, user, filteredCandidateId, onDisengage, onAccept } =
    props;
  const infoModal = useModal();
  const disengagementModal = useModal();

  return (
    <>
      <EngagementItem
        style={EngagementItemCardStyleOverrides}
        engagement={engagement}
        selectingCandidateActive={Boolean(filteredCandidateId)}
        candidateId={filteredCandidateId}
        isPortalUser={user.isPortalUser}
        isPartnerUser={user.isPartnerUser}
        engagementCategoryFilter={engagement.status}
        onShowInfoClick={infoModal.open}
        onAcceptClick={onAccept}
        onDisengageClick={disengagementModal.open}
      />
      {infoModal.isOpen && (
        <EngagementInfoModal
          engagement={engagement}
          user={user}
          onDismiss={infoModal.close}
        />
      )}
      {disengagementModal.isOpen && (
        <DisengageJobModal
          engagement={engagement}
          onSuccess={onDisengage}
          onDismiss={disengagementModal.close}
        />
      )}
    </>
  );
};

type Props = {
  engagement: Engagement;
  user: CurrentUser;
  filteredCandidateId?: string;
  onDisengage: () => void;
  onAccept: () => void;
};

export default EngagementListCard;
